export function encodeSerachParams(record) {
    const searchParams = Object.keys(record).reduce((result, key) => {
        const value = record[key];
        if (typeof value === 'undefined') {
            return result;
        }
        else if (typeof value === 'string' ||
            typeof value === 'number' ||
            typeof value === 'boolean') {
            return [
                ...result,
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            ];
        }
        else {
            return [
                ...result,
                `${encodeURIComponent(key)}=${value.map(encodeURIComponent).join(',')}`
            ];
        }
    }, []);
    if (searchParams.length > 0) {
        return searchParams.join('&');
    }
    else {
        return null;
    }
}
//# sourceMappingURL=search-params.js.map